import { createScript } from "./helpers";
import {
  KnownThirdPartyScripts,
  ThirdPartyPropertyIds,
  ThirdPartyScript,
  ThirdPartyScriptInstaller
} from "./types";
import { getConfig } from "../../../config/app";

const thirdPartyScripts = getConfig("thirdPartyScripts") as ThirdPartyScript[];

const findConfig = (name: KnownThirdPartyScripts) =>
  thirdPartyScripts.find(config => config.name === name) || { scriptUrl: "" };

const getScriptUrl = (name: KnownThirdPartyScripts) => findConfig(name).scriptUrl;

const googleTagManager: ThirdPartyScriptInstaller = {
  safeInstall: () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  },
  script: config =>
    createScript(getScriptUrl(KnownThirdPartyScripts.GoogleTagManager), {
      id: config.googleTagManagerId
    })
};

// This object MUST map the available scripts
const installers = {
  [KnownThirdPartyScripts.GoogleTagManager]: googleTagManager
};

export const getEnabledThirdPartyScripts = () =>
  thirdPartyScripts.filter(t => t.enabled).map(t => installers[t.name]);

export const safeInstallThirdPartyScripts = (config: ThirdPartyPropertyIds) =>
  getEnabledThirdPartyScripts().forEach(installer => installer.safeInstall(config));

export const getThirdPartyScriptsInstallerCallback = () =>
  getEnabledThirdPartyScripts().map(installer => installer.script);
